import { useState } from 'react';

export function DocsPage() {
  const [copiedUrl, setCopiedUrl] = useState<string | null>(null);

  const copyToClipboard = (text: string) => {
    void navigator.clipboard.writeText(text).then(() => {
      setCopiedUrl(text);
      setTimeout(() => setCopiedUrl(null), 2000);
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <svg
                width="100"
                height="23"
                viewBox="0 0 149 28"
                fill="currentColor"
                className="text-black"
              >
                <g clipPath="url(#clip0_1924_2917)">
                  <path
                    d="M27.0229 27.8718C26.8948 27.8718 26.7642 27.8417 26.6461 27.7839L13.9359 21.4841L1.2258 27.7839C0.962053 27.9145 0.650579 27.8995 0.401902 27.7437C0.153225 27.588 0 27.3167 0 27.0228V0.848971C0 0.55508 0.153225 0.281285 0.401902 0.125548C0.653091 -0.0276774 0.967076 -0.0427487 1.22831 0.0903812L13.9359 6.48062L26.6436 0.0903812C26.9073 -0.0427487 27.2188 -0.0276774 27.47 0.125548C27.7212 0.278773 27.8719 0.552568 27.8719 0.846459V27.0228C27.8719 27.3167 27.7212 27.588 27.47 27.7437C27.3344 27.8291 27.1786 27.8718 27.0229 27.8718ZM15.845 20.5371L26.1739 25.6564V15.4154L15.845 20.5346V20.5371ZM1.69552 15.4179V25.6589L12.0244 20.5396L1.69552 15.4179ZM2.71033 14.0263L13.9359 19.5902L25.1616 14.0263L13.9359 8.37961L2.71033 14.0263ZM15.8249 7.43011L26.1764 12.6373V2.22548L15.8249 7.43262V7.43011ZM1.69552 2.22548V12.6373L12.047 7.43011L1.69552 2.22548Z"
                    fill="currentColor"
                  />
                  <path
                    d="M41.8984 0.562683H49.4818L56.8743 22.283L64.3421 0.562683H71.6969V27.4273H67.0098L67.163 4.63947L59.2757 27.4273H54.3222L46.4349 4.63947L46.5505 27.4273H41.9009V0.562683H41.8984ZM74.5278 17.8997C74.5278 11.9541 78.9111 7.8773 84.9296 7.8773C90.948 7.8773 95.3313 11.9541 95.3313 17.8997C95.3313 23.8454 90.9882 27.9975 84.9296 27.9975C78.8709 27.9975 74.5278 23.9207 74.5278 17.8997ZM84.9296 24.3779C88.4362 24.3779 90.6466 21.6726 90.6466 17.8997C90.6466 14.1269 88.4738 11.4969 84.9698 11.4969C81.4657 11.4969 79.215 14.049 79.215 17.8997C79.215 21.7504 81.4632 24.3779 84.9321 24.3779H84.9296ZM98.0466 8.45001H102.505V10.9644C103.191 9.8215 105.173 7.8773 108.526 7.8773C112.603 7.8773 115.652 10.354 115.652 15.2321V27.4248H111.081V15.84C111.081 12.7152 109.556 11.5723 107.155 11.5723C103.917 11.5723 102.658 14.0867 102.658 17.4777V27.4223H98.0466V8.45001ZM120.224 21.4063V11.7657H116.986V8.45001H120.224V3.64979H124.796V8.45001H129.063V11.7657H124.796V21.331C124.796 23.1596 125.672 23.7323 127.272 23.7323H129.063V27.4298H125.901C122.244 27.4298 120.224 25.2947 120.224 21.4088V21.4063ZM130.809 22.2453C130.809 19.54 132.218 17.7867 134.848 16.797C136.755 16.1113 139.191 15.8827 142.469 15.8827H144.185V15.1593C144.185 13.3306 143.346 11.2332 139.842 11.2332C137.099 11.2332 135.765 12.7202 135.65 14.471H131.266C131.533 10.6605 134.924 7.87981 139.917 7.87981C145.594 7.87981 148.644 10.8137 148.644 15.6918V27.4273H144.338V24.9506C143.499 26.1312 141.633 28 137.441 28C133.248 28 130.809 25.7519 130.809 22.2453ZM138.815 24.722C142.243 24.722 144.341 22.6648 144.341 19.5777V18.8166H142.703C140.035 18.8166 138.32 18.9698 137.177 19.427C135.881 19.9595 135.424 20.8361 135.424 22.0569C135.424 23.5037 136.491 24.7245 138.815 24.7245V24.722Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1924_2917">
                    <rect width="148.641" height="28" fill="currentColor" />
                  </clipPath>
                </defs>
              </svg>
              <span className="text-gray-400">|</span>
              <h1 className="text-xl font-semibold text-gray-900">
                URL Parameters
              </h1>
            </div>
            <a
              href="/"
              className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
            >
              ← Back to Map
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-6 py-12">
        {/* Overview */}
        <section className="mb-12">
          <p className="text-lg text-gray-700 leading-relaxed">
            The Monta Web Map supports deep linking through URL parameters,
            enabling you to share specific map views, charge points, and filter
            configurations.
          </p>
          <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-sm text-gray-600 mb-2 font-medium">Base URL</p>
            <code className="text-sm text-blue-600">
              https://maps.monta.app
            </code>
          </div>
        </section>

        {/* Parameters Table */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            All URL Parameters
          </h2>

          <div className="overflow-x-auto border border-gray-200 rounded-lg">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Parameter
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Type
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Values/Range
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Description
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Default
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {/* Location & Navigation */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Location & Navigation
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">lat</td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">-90 to 90</td>
                  <td className="px-4 py-3 text-gray-700">
                    Map center latitude
                  </td>
                  <td className="px-4 py-3 text-gray-600">IP-based</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">lng</td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">-180 to 180</td>
                  <td className="px-4 py-3 text-gray-700">
                    Map center longitude
                  </td>
                  <td className="px-4 py-3 text-gray-600">IP-based</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">zoom</td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">5-17</td>
                  <td className="px-4 py-3 text-gray-700">Map zoom level</td>
                  <td className="px-4 py-3 text-gray-600">varies</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    chargePointId
                  </td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">-</td>
                  <td className="px-4 py-3 text-gray-700">
                    Open specific charge point details
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">siteId</td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">-</td>
                  <td className="px-4 py-3 text-gray-700">
                    Open charge point site/group
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>

                {/* UI Controls */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    UI Controls
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    controls
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide all UI controls
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    filter_ui
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Open filter panel on load
                  </td>
                  <td className="px-4 py-3 text-gray-600">false</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    filter_operator_ui
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide operator filter section
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    best_price
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide the &ldquo;Find best price&rdquo; button in the
                    filter panel
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    location_details
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide the filter sections block (statuses, charge speed,
                    price, operators) in the filter panel
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">locale</td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    en, en-US, da, es, fr, de
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Set language/locale
                  </td>
                  <td className="px-4 py-3 text-gray-600">browser default</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    language_mode
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">fixed</td>
                  <td className="px-4 py-3 text-gray-700">
                    Disables the UI language selector, enforces the locale
                    provided in the locale URL parameter
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">ui_mode</td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    default | operator
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Controls the UI presentation mode. When set to{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      operator
                    </code>
                    , the map is tailored for operator-branded contexts with
                    adjusted UI
                  </td>
                  <td className="px-4 py-3 text-gray-600">default</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    tooltip_style
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">default | light</td>
                  <td className="px-4 py-3 text-gray-700">
                    Controls the marker hover tooltip appearance. When set to{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      light
                    </code>
                    , the tooltip uses a white background with dark text instead
                    of the default dark theme
                  </td>
                  <td className="px-4 py-3 text-gray-600">default</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    filter_price_ui
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide the price-per-kWh filter section (UI only — does
                    not change which charge points are shown)
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    share_ui
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show/hide the Share button
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    anchor_point
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false, 1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Enable the &ldquo;Show location pin&rdquo; toggle and the
                    center pin. Set{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">0</code>{' '}
                    to remove both for embeds
                  </td>
                  <td className="px-4 py-3 text-gray-600">true</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">locked</td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">true, false</td>
                  <td className="px-4 py-3 text-gray-700">
                    Lock the map — disables pan/zoom/scroll and hides the zoom
                    buttons
                  </td>
                  <td className="px-4 py-3 text-gray-600">false</td>
                </tr>

                {/* White-Label & Branding */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    White-Label & Branding
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    operator
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    Operator identifier
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Load operator-specific branding/theme (e.g., norlys, ewii)
                  </td>
                  <td className="px-4 py-3 text-gray-600">monta</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    loaderColor
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (with or without{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Overrides the global loading-line color. Falls back to the
                    operator primary color, then{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      #000000
                    </code>{' '}
                    if not set. Malformed values are silently ignored
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    logoBgColor
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (with or without{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Overrides the operator-logo background color. Falls back to
                    the operator primary color, then{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      #000000
                    </code>{' '}
                    if not set. Only applies when an operator logo is shown.
                    Malformed values are silently ignored
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    operator_scope
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">restrict</td>
                  <td className="px-4 py-3 text-gray-700">
                    Filters the map to display only CPs managed by the target
                    operator
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    map_style
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">default | silver</td>
                  <td className="px-4 py-3 text-gray-700">
                    Base map style. The grayscale &ldquo;Silver&rdquo; theme is
                    the default; use <code>default</code> for the standard
                    Google Maps style
                  </td>
                  <td className="px-4 py-3 text-gray-600">silver</td>
                </tr>
                {/* Marker Styling - applies to clusters AND single pins */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Marker Styling
                    <span className="ml-2 font-normal text-xs text-gray-500">
                      (applies to clusters and single pins; inbound-only)
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_style
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    default, operator, operator_neutral
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Marker center style.{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      default
                    </code>{' '}
                    = black center;{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      operator
                    </code>{' '}
                    = operator-primary center (text contrast auto-computed) +
                    operator icon badge;{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      operator_neutral
                    </code>{' '}
                    = beige center, icon badge without border/padding
                  </td>
                  <td className="px-4 py-3 text-gray-600">default</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_color
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (± <code className="text-xs">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Center/count-circle background accent (text contrast
                    auto-computed). Overrides the{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      marker_style
                    </code>{' '}
                    center color
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_color_available
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (± <code className="text-xs">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    &ldquo;Available&rdquo; ring segment + green single-pin
                    border
                  </td>
                  <td className="px-4 py-3 text-gray-600">#22c55e</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_color_busy
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (± <code className="text-xs">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    &ldquo;Busy&rdquo; ring segment + orange single-pin border
                  </td>
                  <td className="px-4 py-3 text-gray-600">#f97316</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_color_disconnected
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (± <code className="text-xs">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    &ldquo;Disconnected/passive&rdquo; ring segment + grey
                    single-pin border
                  </td>
                  <td className="px-4 py-3 text-gray-600">#6b7280</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_color_error
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    6-char hex (± <code className="text-xs">#</code>)
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    &ldquo;Error&rdquo; ring segment + red single-pin border
                  </td>
                  <td className="px-4 py-3 text-gray-600">#ef4444</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    marker_size
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">xs, s, m</td>
                  <td className="px-4 py-3 text-gray-700">
                    Marker size.{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">s</code>{' '}
                    (small) is the default;{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">m</code>{' '}
                    = automatic count-based sizing
                  </td>
                  <td className="px-4 py-3 text-gray-600">s</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    country_highlight_color
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">6-char hex (± #)</td>
                  <td className="px-4 py-3 text-gray-700">
                    Country-overlay hover highlight color (zoomed-out view).
                    Falls back to operator primary, then{' '}
                    <code className="text-xs bg-gray-100 px-1 rounded">
                      #111827
                    </code>
                  </td>
                  <td className="px-4 py-3 text-gray-600">operator primary</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    country_fill_color
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">6-char hex (± #)</td>
                  <td className="px-4 py-3 text-gray-700">
                    Country-overlay resting fill tint for hoverable
                    (non-highlighted) countries
                  </td>
                  <td className="px-4 py-3 text-gray-600">#3b82f6</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    country_fill_opacity
                  </td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">0–1</td>
                  <td className="px-4 py-3 text-gray-700">
                    Country-overlay resting fill opacity. Raise it to make a
                    custom fill color read over the basemap
                  </td>
                  <td className="px-4 py-3 text-gray-600">0.08</td>
                </tr>

                {/* Availability Filters */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Availability Filters
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    onlyAvailable
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show ONLY available charge points
                  </td>
                  <td className="px-4 py-3 text-gray-600">0 (show all)</td>
                </tr>
                {/* Speed Filters */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Speed Filters
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">slow</td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show slow chargers (0-22kW)
                  </td>
                  <td className="px-4 py-3 text-gray-600">1 (show)</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">fast</td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show fast chargers (23-99kW)
                  </td>
                  <td className="px-4 py-3 text-gray-600">1 (show)</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    ultraFast
                  </td>
                  <td className="px-4 py-3 text-gray-600">boolean</td>
                  <td className="px-4 py-3 text-gray-600">1, 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Show ultra-fast chargers (100+kW)
                  </td>
                  <td className="px-4 py-3 text-gray-600">1 (show)</td>
                </tr>

                {/* Operator & Team Filters */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Operator & Team Filters
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    operatorIds
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    Comma-separated numbers
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Filter by specific operator IDs (global)
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">teamIds</td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    Comma-separated numbers
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Filter by team IDs
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>

                {/* Price Filters */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Price Filters
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="px-4 py-3 font-mono text-blue-600">
                    maxPrice
                  </td>
                  <td className="px-4 py-3 text-gray-600">number</td>
                  <td className="px-4 py-3 text-gray-600">&gt; 0</td>
                  <td className="px-4 py-3 text-gray-700">
                    Maximum price per kWh (local currency)
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>

                {/* Promotion Filters */}
                <tr className="bg-blue-50">
                  <td
                    colSpan={5}
                    className="px-4 py-2 font-semibold text-gray-900"
                  >
                    Promotion Filters
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-mono text-blue-600">
                    promotionIds
                  </td>
                  <td className="px-4 py-3 text-gray-600">string</td>
                  <td className="px-4 py-3 text-gray-600">
                    Comma-separated numbers
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    Filters the view to display only CPs associated with
                    specific promotion IDs
                  </td>
                  <td className="px-4 py-3 text-gray-600">none</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Important Notes */}
          <div className="mt-6 p-6 bg-blue-50 rounded-lg border border-blue-200">
            <h3 className="font-semibold text-gray-900 mb-3">
              Important Notes
            </h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>All parameters are optional</strong> - defaults apply
                  when omitted
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>Boolean parameters</strong> accept: 1, 0, true, false
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>Hex color parameters</strong> (loaderColor,
                  logoBgColor, marker_color, marker_color_*): pass the 6 hex
                  digits <strong>without</strong> a leading{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    #
                  </code>{' '}
                  (e.g.{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    38761d
                  </code>
                  ). A literal{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    #
                  </code>{' '}
                  in a URL starts the fragment and never reaches the param —
                  omit it or encode it as{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    %23
                  </code>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>Multiple filters combine with AND logic</strong> - all
                  conditions must be met
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <div>
                  <strong>operator vs operatorIds</strong>:
                  <ul className="ml-4 mt-1 space-y-1">
                    <li>
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        operator=norlys
                      </code>{' '}
                      → Branding/theme only (shows all CPs)
                    </li>
                    <li>
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        operatorIds=602
                      </code>{' '}
                      → Filters CPs by operator (default theme)
                    </li>
                    <li>
                      Both can be combined:{' '}
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        operator=norlys&operatorIds=602
                      </code>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>operatorIds and teamIds</strong> are global
                  identifiers that work everywhere
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <div>
                  <strong>maxPrice vs filter_price_ui</strong> are independent:
                  <ul className="ml-4 mt-1 space-y-1">
                    <li>
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        filter_price_ui
                      </code>{' '}
                      controls whether the price input is shown
                    </li>
                    <li>
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        maxPrice
                      </code>{' '}
                      sets the applied filter value (absent/0 = no price filter)
                    </li>
                    <li>
                      An embed can hide the input while still applying a fixed{' '}
                      <code className="text-xs bg-white px-1 py-0.5 rounded">
                        maxPrice
                      </code>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">•</span>
                <span>
                  <strong>operator_scope=restrict</strong> is the legacy
                  combined &ldquo;hide + restrict&rdquo; control. For new
                  embeds, prefer the dedicated{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    filter_operator_ui
                  </code>{' '}
                  /{' '}
                  <code className="text-xs bg-white px-1 py-0.5 rounded">
                    filter_price_ui
                  </code>{' '}
                  params, which hide UI without restricting results
                </span>
              </li>
            </ul>
          </div>
        </section>

        {/* Use Cases */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Use Cases & Examples
          </h2>

          <div className="space-y-6">
            {/* Example 1 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                1. Share Current Map View
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                The URL automatically updates with your current position and
                filters. You can either:
              </p>
              <ul className="text-sm text-gray-600 space-y-1 ml-6 list-disc">
                <li>Click the share button in the map interface</li>
                <li>Copy the URL directly from the browser address bar</li>
              </ul>
            </div>

            {/* Example 2 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                2. Embed in Website/App
              </h3>
              <pre className="text-xs bg-gray-900 text-gray-100 p-4 rounded overflow-x-auto mt-3">
                {`<iframe
  src="https://maps.monta.app?lat=55.6903&lng=12.4691&zoom=15.0&controls=false"
  width="100%"
  height="600px"
  style="border: none;">
</iframe>`}
              </pre>
            </div>

            {/* Example 3 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                3. Link to Specific Charge Point
              </h3>
              <div className="relative group mt-2">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?chargePointId=12345
                </code>
                <button
                  onClick={() =>
                    copyToClipboard(
                      'https://maps.monta.app?chargePointId=12345'
                    )
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl ===
                  'https://maps.monta.app?chargePointId=12345' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 4 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                4. White-Label for Partner Operators
              </h3>
              <div className="relative group mt-2">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?operator=norlys&operatorIds=602
                </code>
                <button
                  onClick={() =>
                    copyToClipboard(
                      'https://maps.monta.app?operator=norlys&operatorIds=602'
                    )
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl ===
                  'https://maps.monta.app?operator=norlys&operatorIds=602' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 5 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                5. Show Only Available Charge Points
              </h3>
              <div className="relative group mt-2">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?onlyAvailable=1
                </code>
                <button
                  onClick={() =>
                    copyToClipboard('https://maps.monta.app?onlyAvailable=1')
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl === 'https://maps.monta.app?onlyAvailable=1' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 6 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                6. Filter by Speed & Price
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Show only ultra-fast chargers under 0.40/kWh:
              </p>
              <div className="relative group">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?slow=0&fast=0&maxPrice=0.40
                </code>
                <button
                  onClick={() =>
                    copyToClipboard(
                      'https://maps.monta.app?slow=0&fast=0&maxPrice=0.40'
                    )
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl ===
                  'https://maps.monta.app?slow=0&fast=0&maxPrice=0.40' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 7 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                7. Multi-Operator View
              </h3>
              <div className="relative group mt-2">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?operatorIds=602,789,1024
                </code>
                <button
                  onClick={() =>
                    copyToClipboard(
                      'https://maps.monta.app?operatorIds=602,789,1024'
                    )
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl ===
                  'https://maps.monta.app?operatorIds=602,789,1024' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 8 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                8. Team-Specific View
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Show charge points from specific charging network teams:
              </p>
              <div className="relative group">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?teamIds=123,456
                </code>
                <button
                  onClick={() =>
                    copyToClipboard('https://maps.monta.app?teamIds=123,456')
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl === 'https://maps.monta.app?teamIds=123,456' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 9 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                9. Localized Link
              </h3>
              <div className="relative group mt-2">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block">
                  https://maps.monta.app?locale=da
                </code>
                <button
                  onClick={() =>
                    copyToClipboard('https://maps.monta.app?locale=da')
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl === 'https://maps.monta.app?locale=da' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Example 10 */}
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                10. Complete Example
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Copenhagen, Danish, only available ultra-fast chargers under
                0.35/kWh:
              </p>
              <div className="relative group">
                <code className="text-sm bg-gray-100 text-blue-600 px-3 py-2 pr-12 rounded block break-all">
                  https://maps.monta.app?lat=55.6903&lng=12.4691&zoom=12&locale=da&onlyAvailable=1&slow=0&fast=0&maxPrice=0.35
                </code>
                <button
                  onClick={() =>
                    copyToClipboard(
                      'https://maps.monta.app?lat=55.6903&lng=12.4691&zoom=12&locale=da&onlyAvailable=1&slow=0&fast=0&maxPrice=0.35'
                    )
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-200 rounded transition-colors"
                  title="Copy to clipboard"
                >
                  {copiedUrl ===
                  'https://maps.monta.app?lat=55.6903&lng=12.4691&zoom=12&locale=da&onlyAvailable=1&slow=0&fast=0&maxPrice=0.35' ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-16">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-600 text-center">
            © {new Date().getFullYear()} Monta. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
